/* eslint-disable class-methods-use-this */
const { getV2CreditChargesAppNameList, getV2DebitChargesAppNameList } = require('pando-constants');
const { isEmpty } = require('lodash');

class TotalAmount {
  totalAmountCalculation(paymentCharges) {
    const data = paymentCharges;
    // credit and debit in the context of transporter
    const debit = getV2DebitChargesAppNameList();
    const credit = getV2CreditChargesAppNameList();
    const debitCharges = debit.reduce((totalDebit, debitCharge) => {
      if (data[debitCharge] && !isNaN(data[debitCharge])) {
        return parseFloat(data[debitCharge]) + totalDebit;
      }
      return totalDebit;
    }, 0);
    const creditCharges = credit.reduce((totalCredit, creditCharge) => {
      if (creditCharge === 'custom_charges' && !isEmpty(data[creditCharge])) {
        const customChargeTotal = Object.values(data[creditCharge]).reduce((acc, charge) => charge + acc, 0);
        return parseFloat(customChargeTotal) + totalCredit;
      }
      // if ((creditCharge === 'customSourceCharge' && !isEmpty(data[creditCharge])) || (creditCharge === 'customDestinationCharge' && !isEmpty(data[creditCharge]))) {
      //   const customChargeTotal = Object.values(data[creditCharge]).reduce((sum, value) => sum + value.amount, 0);
      //   return parseFloat(customChargeTotal) + totalCredit;
      // }
      if (data[creditCharge] && !isNaN(data[creditCharge])) {
        return parseFloat(data[creditCharge]) + totalCredit;
      }
      return totalCredit;
    }, 0);
    data.totalAmount = creditCharges - debitCharges;
    return data;
  }
}

module.exports = TotalAmount;
